export enum UserInvitationStatus {
  New,
  Revoked,
  Accepted
}
